module.exports = __webpack_public_path__ + "static/img/other2.e30e37a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/other2.png
// module id = RF86
// module chunks = 1